import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Menubar } from 'primereact/menubar';
import type { MenuItem } from 'primereact/menuitem';
import { X } from 'lucide-react';
import { useHistory, useLocation } from 'react-router-dom';

import { CLIENT_DETAILS_UPDATED_EVENT } from '../../../../constants';
import { MainMenuProps, RootStatePermission } from '../interface/app-header';
import styles from '../css/navbar.module.css';
import PullOrder from '../SideMenu/PullOrder';
import { menuItemsList, AppMenuItem } from '../constants/main-menu.constants';

const MainMenu: React.FC<MainMenuProps> = ({
  slideDrawer,
  setSlideDrawer,
  isLandscape,
}) => {
  const history = useHistory();
  const location = useLocation();
  const { permissionList } = useSelector(
    (state: RootStatePermission) => state?.permissionsList
  );
  const [dailogVisible, setDailogVisible] = useState(false);
  const [clientDetailsVersion, setClientDetailsVersion] = useState(0);
  const clientId = localStorage.getItem('client_id');

  useEffect(() => {
    const handleClientDetailsUpdated = () => {
      setClientDetailsVersion(version => version + 1);
    };

    window.addEventListener(
      CLIENT_DETAILS_UPDATED_EVENT,
      handleClientDetailsUpdated
    );

    return () => {
      window.removeEventListener(
        CLIENT_DETAILS_UPDATED_EVENT,
        handleClientDetailsUpdated
      );
    };
  }, []);

  useEffect(() => {
    setSlideDrawer(false);
  }, [location.pathname]);
  const renderMenuItemsOther = useMemo<AppMenuItem[]>(
    () =>
      menuItemsList(
        setDailogVisible,
        clientId,
        permissionList,
        history,
        location.pathname
      ),
    [clientDetailsVersion, clientId, permissionList, location.pathname]
  );
  const myPermission = localStorage.getItem('webPermission') === 'true';

  return (
    <>
      <aside
        className={`top-0 bottom-0 shadow-2 fixed z-300 transition-ease-in-out transition-duration-20 left-0 pt-0 xl:pt-3 ${isLandscape ? 'landscape-menu' : 'portrait-menu'} ${!slideDrawer && styles.mobileSidenav} ${slideDrawer && styles.asideOverlay}`}
      >
        <div className={`card flex side-menu-list ${styles.sideBar}`}>
          {!myPermission && (
            <>
              <Menubar
                model={renderMenuItemsOther as unknown as MenuItem[]}
                className="bg-transparent"
                pt={{
                  root: {
                    className: `border-none p-0`,
                  },
                  menuitem: {
                    className: 'w-full',
                  },
                  menu: {
                    className: `landscape-view-align bg-transparent shadow-none top-0 py-0`,
                  },
                  action: {
                    className: 'py-2 px-2 flex-column group',
                  },
                  icon: {
                    className: 'mr-0 icon-zoom-in group-hover:text-red-900',
                  },
                  label: {
                    className: 'text-left',
                  },
                  submenu: {
                    className: 'border-round-lg border-200 border-1',
                  },
                  button: {
                    onClick: () => {
                      setSlideDrawer(true);
                    },
                    className: `${isLandscape && 'landscape-menu-open'} absolute text-primary-500 mt-1 md:mt-3 bg-transparent shadow-none`,
                  },
                }}
              />
              {slideDrawer && (
                <X
                  className={`cursor-pointer pf-surface-light-primary w-2rem h-2rem text-white p-1 mx-2 z-600 ${!isLandscape ? 'absolute' : 'landscape-menu-close'} border-round-3xl ${styles.closeHamburger}`}
                  onClick={() => setSlideDrawer(false)}
                />
              )}
            </>
          )}
          <PullOrder
            dailogVisible={dailogVisible}
            setDailogVisible={setDailogVisible}
          />
        </div>
      </aside>
    </>
  );
};

export default MainMenu;
